<label 
  class="base-input-label w-full"
  [ngClass]="{ 'opacity-50': disabled }"
>
    <p>{{ title }} <span *ngIf="_required">*</span></p>
  

    <input  #input  
            class="base-text-input" 
            [attr.id]="inputId" 
            [attr.type]="type" 
            [attr.name]="name" 
            [ngStyle]="style" 
            [ngClass]="styleClass" 
            [attr.placeholder]="placeholder" 
            [attr.title]="title"
            [attr.size]="size" 
            [attr.autocomplete]="autocomplete" 
            [attr.maxlength]="maxlength" 
            [attr.tabindex]="tabindex" 
            [attr.aria-label]="ariaLabel" 
            [attr.aria-required]="ariaRequired" 
            [disabled]="disabled" 
            [readonly]="readonly" 
            [attr.required]="required"
            (focus)="onInputFocus($event)" 
            (blur)="onInputBlur($event)" 
            (keydown)="onInputKeydown($event)" 
            (keypress)="onKeyPress($event)" 
            [attr.autofocus]="autoFocus"
            (input)="onInputChange($event)" 
            (paste)="handleInputChange($event)"
    >
</label>

